var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarsImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 7.95898V6.64062C25 5.13047 23.7758 3.90625 22.2656 3.90625H2.73438C1.22422 3.90625 0 5.13047 0 6.64062V7.95898C0 8.0938 0.109326 8.20312 0.244141 8.20312H24.7559C24.8907 8.20312 25 8.0938 25 7.95898Z",
    fill: "#5CA1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0098V18.3594C0 19.8695 1.22422 21.0938 2.73438 21.0938H22.2656C23.7758 21.0938 25 19.8695 25 18.3594V10.0098C25 9.87495 24.8907 9.76562 24.7559 9.76562H0.244141C0.109326 9.76562 0 9.87495 0 10.0098ZM6.25 16.4062C6.25 16.8377 5.9002 17.1875 5.46875 17.1875H4.6875C4.25605 17.1875 3.90625 16.8377 3.90625 16.4062V15.625C3.90625 15.1936 4.25605 14.8438 4.6875 14.8438H5.46875C5.9002 14.8438 6.25 15.1936 6.25 15.625V16.4062Z",
    fill: "#5CA1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarsImg);
export default __webpack_public_path__ + "static/media/cars-img.5ab6a95bc107630b5adbdc0d679dafd7.svg";
export { ForwardRef as ReactComponent };